import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

import {ref} from "vue";
  import {useApp} from "@hview/hview-vue3/packages/hooks";
  import {createProjectApi, getProjectInfoApi} from "@/api/kh";
  import {Notice} from "@hview/hview-vue3/packages";
  
import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: "ProjectDialog",
  
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["on-load"],
  setup(__props, { expose: __expose, emit: __emit }) {

  const {visible, loading} = useApp();
  const title = ref("");

  const emits = __emit;

  const formRef = ref();

  const model = ref({
    id: "",
    name: "",
    description: ""
  });

  const uiModel = ref({});


  const rules = ref({
    name: [{
      required: true,
      message: "请输入项目名称",
      trigger: ["blur", "change"]
    }],
    description: [{
      required: true,
      message: "请输入项目描述",
      trigger: ["blur", "change"]
    }]
  });

  /**
   * @description 加载数据
   */
  const load = () => {
    loading.value = true;
    getProjectInfoApi(model.value).then((res: any) => {
      uiModel.value = res.data;
    }).finally(() => {
      loading.value = false;
    });
  }

  /**
   * @description 打开弹窗
   */
  const open = (id: string) => {
    visible.value = true;
    title.value = "项目详情";
    model.value.id = id;
    load();
  }

  /**
   * @description 创建项目
   */
  const submit = () => {
    formRef.value.validate((valid: boolean) => {
      if (valid) {
        loading.value = true;
        createProjectApi(model.value).then(() => {
          Notice.success("创建成功");
          visible.value = false;
          emits("on-load");
        }).finally(() => {
          loading.value = false;
        });
      }
    });

  }

  /**
   * @description 创建项目
   */
  const create = () => {
    visible.value = true;
    model.value.id = "";
    title.value = "创建项目";
  }

  __expose({
    open,
    create
  });


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_h_dict = _resolveComponent("h-dict")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    title: title.value,
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "750"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (model.value.id)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("关闭")
              ])),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (visible.value = false)),
                link: ""
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("关闭")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                loading: _unref(loading),
                type: "primary",
                onClick: submit
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("创建")
                ])),
                _: 1
              }, 8, ["loading"])
            ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (model.value.id)
          ? (_openBlock(), _createBlock(_component_el_descriptions, {
              key: 0,
              column: 2,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "项目ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(uiModel.value.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  width: "130",
                  label: "项目名称"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(uiModel.value.project_name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  span: "2",
                  label: "状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_h_dict, {
                      mode: "text",
                      dictKey: "status_type",
                      modelValue: uiModel.value.status,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uiModel.value.status) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  width: "130",
                  label: "项目描述"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(uiModel.value.project_desc), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              ref_key: "formRef",
              ref: formRef,
              onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
              model: model.value,
              rules: rules.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "项目名称",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: model.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.name) = $event)),
                      placeholder: "请输入项目名称"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "项目描述",
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      rows: 5,
                      modelValue: model.value.description,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.description) = $event)),
                      placeholder: "请输入项目描述"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onVnodeBeforeMount", "model", "rules"]))
      ])), [
        [_directive_loading, _unref(loading)]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})